import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=4b4c769c&scoped=true&"
import script from "./priceList.vue?vue&type=script&lang=js&"
export * from "./priceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c769c",
  null
  
)

export default component.exports